import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Button,
  Collapse,
  Divider,
  IconButton,
  List,
  ListItem,
  Popover,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import InfoHistorialIcon from "../UI/InfoHistorialIcon";
import IconEstado from "../UI/IconEstado";
// import { PracticaItem } from "./PracticaItem";
// import { ModalAuditar } from "./ModalAuditar";
import { ModalHistorialCambios } from "../gestionAuditoria/ModalHistorialCambios";
import { postTomarPresupuesto, setActiveStep, setAfiliadoSeleccionado, setPresupuestoSeleccionado, setShowForm } from "../../../actions/autorizaciones/Autorizaciones";

import { AUTORIZACIONES_PRESUPUESTOS_ESTADOS, STEPPER_AUTORIZACIONES } from "../../../utils/constants";
import { ModalAuditarPresupuesto } from "./ModalAuditarPresupuesto";
import { PracticaPresupuestoItem } from "./PracticaPresupuestoItem";

const useRowStyles = makeStyles({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
  },
  popover: {
    pointerEvents: 'none',
  },
  spacingPop: {
    padding: '1em'
  }
});

const optionsfecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
};

const formatPeso = new Intl.NumberFormat('es-CO', {
  style: 'currency',
  currency: 'COP',
  minimumFractionDigits: 0
})

export const PresupuestoItem = (props) => {
  const dispatch = useDispatch();
  const { item } = props;
  const { idUsuario } = useSelector((state) => state.auth);
  const [open, setOpen] = React.useState(props.expandirPracticas);
  const [openModalAuditar, setOpenModalAuditar] = useState(false);
  const [openModalHistorialCambios, setOpenModalHistorialCambios] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const openPop = Boolean(anchorEl);
  const classes = useRowStyles();

  const postIrAPresupuesto = (item) => {
    dispatch(setPresupuestoSeleccionado(item));
    dispatch(setAfiliadoSeleccionado(item.afiliado));
    dispatch(setShowForm(true));
    dispatch(setActiveStep(STEPPER_AUTORIZACIONES.DETALLES_ORDEN));
    props.setRedirect(true);
  }

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      {openModalAuditar && (
        <ModalAuditarPresupuesto
          open={openModalAuditar}
          closeModalHandler={() => {
            setOpenModalAuditar(false);
          }}
          presupuesto={item}
          filtros={props.filtros}
        />
      )}
      {openModalHistorialCambios && (
        <ModalHistorialCambios
          open={openModalHistorialCambios}
          closeModalHandler={() => {
            setOpenModalHistorialCambios(false);
          }}
          presupuesto={item}
          openPresupuesto
          titulo={`Presupuesto N° ${item.idPresupuesto}`}
        />
      )}
      <TableRow className={classes.root}>
        <TableCell align="center" sx={{ padding: "10px" }}>
          <InfoHistorialIcon onClick={() => setOpenModalHistorialCambios(true)} />
        </TableCell>
        <TableCell align="right">
          {item.urgente && (
            <IconEstado
              texto={"U"}
              useColorTable={true}
              descripcion={'Urgente'}
              extraMarginRight={true}
              backgroundColor={"red"}
            />
          )}
          <IconEstado
            useColorTable={true}
            texto={item?.estadoPresupuesto?.letra}
            backgroundColor={item?.estadoPresupuesto?.color}
            descripcion={item?.estadoPresupuesto?.descripcion}
          />
        </TableCell>
        <TableCell align="center">
          {new Date(item.fechaCarga).toLocaleString("es", optionsfecha)}
        </TableCell>
        {item?.idEstadoPresupuesto === AUTORIZACIONES_PRESUPUESTOS_ESTADOS.PENDIENTE_CONTRATOS &&
          <TableCell align="center">
            {new Date(item.fechaDerivacion).toLocaleString("es", optionsfecha)}
          </TableCell>}
        <TableCell align="left">{item.idPresupuesto}</TableCell>
        <TableCell align="left"
          aria-owns={openPop ? 'mouse-over-popover' : undefined}
          aria-haspopup="true"
          onMouseEnter={handlePopoverOpen}
          onMouseLeave={handlePopoverClose}
        >
          {item.tipoPresupuesto.descripcionTipo}
        </TableCell>
        <Popover
          id="mouse-over-popover"
          className={classes.popover}
          open={openPop}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'center',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'center',
            horizontal: 'center',
          }}
          onClose={handlePopoverClose}
          disableRestoreFocus
        >
          <List className={classes.spacingPop}>
            <ListItem>
              <Typography>Nombre Prestador: {item.nombrePrestador}</Typography>
            </ListItem>
            <Divider />
            <ListItem>
              <Typography>Cuit Prestador: {item.cuitPrestador}</Typography>
            </ListItem>
            <Divider />
            <ListItem>
              <Typography>Valor Presupuesto: {formatPeso.format(item.valor)}</Typography>
            </ListItem>
          </List>
        </Popover>
        <TableCell align="left">{item.conInternacion ? 'Con Internación' : item.soloMateriales ? 'Solo Materiales' : 'Ambulatorio'}</TableCell>
        <TableCell align="left">{item.diagnostico?.problema}</TableCell>
        <TableCell>
          {item.practicas.length > 0 && (
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          )}
        </TableCell>
        <TableCell align="left">{item.afiliado?.apellido_y_nombre}</TableCell>
        <TableCell align="left">{item.afiliado?.carnet}</TableCell>
        <TableCell align="left">
          {item.seccional?.descripcion_seccional}
        </TableCell>
        <TableCell align="left">
          {item?.bandejaAutorizacion?.descripcion}
        </TableCell>
        <TableCell align="left">
          {
            item.presupuestosTomados?.length === 0
              ? null
              : item?.presupuestosTomados[0]?.usuarioTomado?.userName
          }
        </TableCell>
        <TableCell>
          {!props.fromCompras && (item?.idEstadoPresupuesto === AUTORIZACIONES_PRESUPUESTOS_ESTADOS.EN_CARGA
            || item?.idEstadoPresupuesto === AUTORIZACIONES_PRESUPUESTOS_ESTADOS.DEVOLUCION) && (
              <Button
                style={{ fontSize: "0.8rem" }}
                variant="contained"
                color="primary"
                onClick={() => {
                  postIrAPresupuesto(item);
                }}
              >
                Ir
              </Button>
            )}
          {props.tieneAreaAutorizaciones && ((item?.idEstadoPresupuesto ===
            AUTORIZACIONES_PRESUPUESTOS_ESTADOS.AUDITORIA && props.esAuditorPresupuestos) ||
            item?.idEstadoPresupuesto === AUTORIZACIONES_PRESUPUESTOS_ESTADOS.PENDIENTE ||
            (item?.idEstadoPresupuesto ===
              AUTORIZACIONES_PRESUPUESTOS_ESTADOS.PENDIENTE_CONTRATOS && props.esAuditorContratos)) && (
              <Button
                style={{ fontSize: "0.8rem" }}
                disabled={
                  item.presupuestosTomados?.length > 0 &&
                  item.presupuestosTomados[0]?.idUsuarioTomado !== idUsuario
                }
                variant="contained"
                color="primary"
                onClick={() => {
                  dispatch(postTomarPresupuesto(item, setOpenModalAuditar));
                }}
              >
                Auditar
              </Button>
            )}
          {(item?.idEstadoPresupuesto ===
            AUTORIZACIONES_PRESUPUESTOS_ESTADOS.AUTORIZADO ||
            item?.idEstadoPresupuesto ===
            AUTORIZACIONES_PRESUPUESTOS_ESTADOS.RECHAZADO /*||
            (item?.idEstadoPresupuesto ===
              AUTORIZACIONES_PRESUPUESTOS_ESTADOS.PENDIENTE_CONTRATOS && props.esAuditorContratos)*/) && (
              <Button
                style={{ fontSize: "0.8rem" }}
                variant="contained"
                color="primary"
                onClick={() => {
                  setOpenModalAuditar(true);
                  dispatch(setPresupuestoSeleccionado(item));
                }}
              >
                Ver
              </Button>
            )}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell
          style={{ paddingBottom: 0, paddingTop: 0, paddingLeft: 100 }}
          colSpan={11}
        >
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Typography variant="h6" gutterBottom component="div">
                Practicas
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>Práctica</TableCell>
                    <TableCell align="right">Cantidad</TableCell>
                    <TableCell align="center">SURGE</TableCell>
                    <TableCell>Materiales</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {item.practicas.map((item) => (
                    <PracticaPresupuestoItem
                      key={item?.idCodNom?.toString()}
                      conInternacion={item.conInternacion}
                      item={item}
                    />
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};
